module.exports = __webpack_public_path__ + "img/sculpture-02.9860adec.jpg";